import React, { Component, Fragment } from 'react';
import { Router } from '../configs/routes';
import { Fund } from '../models/singleFundPages';
import amcStyles from '../styles/amcs.scss';
import Header from '../components/nextHead';
import BreadCrumb from '../components/breadcrumb';
import { FUND_PURCHASE_MODES } from '../constants/fundPages';
import Error from '../components/Error404';
import Tabs from '../components/ui/tabs';
import { AMC_FUND_LIST_HEADER_SEARCH_NEW } from '../constants';
import { handleAmcPage, amcTitleCase } from './../utils';
import { parse } from 'query-string';
import { Api } from '../api';
import searchStyles from '../styles/search.scss';
import cx from 'classnames';
import Loader from '../components/ui/Loader';
import {
  filterDataMap,
  filterCategoryMap,
  algoliaIndex,
  stagingAlgoliaIndex,
} from '../constants/searchConstants';
import PaginationNew from '../components/ui/paginationNew';
import getConfig from 'next/config';
import AMCFundTableNew from '../components/amc/amcFundTableNew';
import { presentYear } from '../constants/getPresentYear';
import { isSmallScreen } from '../utils/commonUtils';
import AmcBasicInfo from '../components/amcNew/AmcBasicInfo';
import AmcBlurb from '../components/amcNew/AmcBlurb';
import LogoImage from '../components/amcNew/LogoImage';
import AboutAmc from '../components/amcNew/AboutAmc';
import HowToInvest from '../components/amcNew/HowToInvest';
import DocumentsRequired from '../components/amcNew/DocumentsRequired';
import CustomerCare from '../components/amcNew/CustomerCare';
import FAQs from '../components/amcNew/FAQs';
import ReturnsDropdown from '../components/amcNew/ReturnsDropdown';
import FundTableFilter from '../components/amcNew/FundTableFilter';
import { getTableItems } from '../utils/amcUtils';
import CIOs from '../components/amcNew/CIOs';

const { publicRuntimeConfig } = getConfig();

interface Props {
  funds: Fund[];
  slug: string;
  primarySlug: string;
  statusCode: number;
  url: any;
  amcBasicsDetails: any;
  amcs: any;
  issuingAuthority: string;
  customContent: string;
}

interface State {
  currentFunds: any[];
  selectedTab: string;
  tabs: object[];
  query: string;
  facetFilters: any;
  issuingAuthority: string;
  currentSelectedPage: number;
  totalResults: number;
  resultPerPage: number;
  totalPages: number;
  loading: boolean;
  filterCategoryValueMap?: any;
  sortBy: string;
  showFilterModal: boolean;
  selectedTabFilter: string;
  filtersToApply?: any;
  selectedReturnTime?: string;
  otherAMCList: any;
  loadingTopTable: boolean;
  topFunds: any;
  amcData: any;
  isFilterOpen: boolean;
  amcFaqs: any;
  expandedFaqIndex: number;
  amcEmail: string;
  isMobile: boolean;
  amcCIOs: any;
  expandedCIOIndex: number | null;
}

const api = new Api();

class AmcFundsListNew extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const filters = JSON.parse(props.url.query.filters || '{}');
    this.state = this.setInitialState(props, filters);
    this.searchFund(this.state.query, 0);
  }

  private setInitialState(props: Props, filters: any) {
    const {
      url: {
        query: { tab },
      },
      issuingAuthority,
    } = props;

    const getDefaultTab = (tabFromUrl: string) => {
      return [FUND_PURCHASE_MODES.regular, FUND_PURCHASE_MODES.direct].includes(
        tabFromUrl
      )
        ? tabFromUrl
        : FUND_PURCHASE_MODES.direct;
    };

    const getSortBy = (sortByNew: string) => {
      if (sortByNew) {
        return sortByNew;
      } else if (
        publicRuntimeConfig.env === 'development' ||
        publicRuntimeConfig.env === 'qa'
      ) {
        return stagingAlgoliaIndex;
      } else {
        return algoliaIndex;
      }
    };

    const {
      query,
      facetFilters,
      filterCategoryValueMap,
      sortBy,
      currentSelectedPage,
    } = filters;

    const selectedTab = getDefaultTab(tab);

    return {
      currentFunds: [],
      otherAMCList: [],
      selectedReturnTime: 'return5yr',
      selectedTab,
      tabs: [
        {
          label: 'Direct Funds',
          key: FUND_PURCHASE_MODES.direct,
        },
        {
          label: 'Regular Funds',
          key: FUND_PURCHASE_MODES.regular,
        },
      ],
      query: query || '',
      facetFilters: facetFilters || [],
      issuingAuthority: issuingAuthority || '',
      currentSelectedPage: currentSelectedPage || 0,
      totalResults: 0,
      resultPerPage: 0,
      totalPages: 0,
      loading: true,
      filterCategoryValueMap: filterCategoryValueMap || {
        fundType: [],
        purchaseMode: [selectedTab],
        enabled: [],
        issuingAuthority: [issuingAuthority],
        'fundMetaData.exitLoad.percentage': [],
        'categoryFilter.categoryFilterValue': [],
        'fundMetaData.risk': [],
        'fundMetaData.morningStarRating': [],
      },
      sortBy: getSortBy(sortBy),
      showFilterModal: false,
      selectedTabFilter: 'category',
      filtersToApply: null,
      isFilterOpen: false,
      expandedFaqIndex: null,
      isMobile: false,
      expandedCIOIndex: null,
    };
  }
  public async componentDidMount() {
    await this.callAmcList();
    this.searchTopFunds();
    this.fetchAMCBlurbData();
    this.fetchCIOs();
    this.fetchFAQs();
    const isMobile = isSmallScreen();
    this.setState({ isMobile });
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.setState({ isMobile: isSmallScreen() });
  };

  private callAmcList() {
    const { issuingAuthority } = this.state;
    handleAmcPage(api).then((response: any) => {
      let otherAMCRes = response['amcs'];
      otherAMCRes = otherAMCRes.filter(
        (item) =>
          item['issuingAuthority'] !== issuingAuthority &&
          item['issuingAuthority']
      );
      otherAMCRes = otherAMCRes.slice(0, 9);
      this.setState({
        otherAMCList: otherAMCRes,
      });
      this.fetchEmail();
    });
  }

  private updateQueries = (clearAll?: boolean) => {
    const {
      query,
      facetFilters,
      filterCategoryValueMap,
      sortBy,
      currentSelectedPage,
    } = this.state;
    const filters = JSON.stringify({
      query,
      facetFilters,
      filterCategoryValueMap,
      sortBy,
      currentSelectedPage,
    });
    const queries = parse(location.search);
    if (clearAll) {
      delete queries.filters;
    } else {
      queries.filters = filters;
    }
  };

  public async searchFund(
    value: string,
    pageNo?: number,
    hitsPerPage: number = 6,
    indexName: string = 'clearsave_all_funds_rating_desc_with_nfo'
  ) {
    const { query, filterCategoryValueMap, sortBy } = this.state;
    const facetFilters = Object.keys(filterCategoryValueMap).map((key) => {
      return filterCategoryValueMap[key].map(
        (category) => `${key}:${category}`
      );
    });
    const searchIndex = indexName || sortBy;
    const searchResults = await api.searchFund(
      value,
      pageNo,
      facetFilters,
      searchIndex,
      hitsPerPage
    );
    if (query && query !== searchResults.query) {
      return;
    }
    const {
      hits: currentFunds,
      hitsPerPage: resultPerPage,
      nbHits: totalResults,
      nbPages: totalPages,
    } = searchResults;
    this.setState({
      currentFunds,
      resultPerPage,
      totalResults,
      totalPages,
      loading: false,
    });
    return currentFunds;
  }

  public async searchTopFunds(hitsPerPage: number = 10, indexName?: string) {
    const { query, sortBy, issuingAuthority } = this.state;
    const value = '';
    const facetFilters = [
      'purchaseMode:DIRECT',
      'issuingAuthority:' + issuingAuthority,
      [
        'fundMetaData.morningStarRating:3',
        'fundMetaData.morningStarRating:4',
        'fundMetaData.morningStarRating:5',
      ],
    ];
    const searchIndex = indexName || sortBy;
    const searchResults = await api.searchFund(
      value,
      0,
      facetFilters,
      searchIndex,
      hitsPerPage
    );
    if (query && query !== searchResults.query) {
      return;
    }
    const { hits: topFunds } = searchResults;
    this.setState({
      topFunds,
      loadingTopTable: false,
    });
    return topFunds;
  }

  public async fetchAMCBlurbData() {
    const { query, sortBy, issuingAuthority } = this.state;
    const value = '';
    const facetFilters = ['issuingAuthority:' + issuingAuthority];
    const searchResults = await api.searchFund(
      value,
      0,
      facetFilters,
      sortBy,
      500
    );
    if (query && query !== searchResults.query) {
      return;
    }
    const { hits: allFunds, nbHits: amcSchemes } = searchResults;

    let amcAum = 0;
    for (const fund of allFunds) {
      if (!fund || !fund.fundMetaData) {
        continue;
      }
      amcAum += Number(fund.fundMetaData.aum);
    }
    const amcData = {
      amcAum,
      amcSchemes,
    };
    this.setState({
      amcData,
    });
    return amcData;
  }

  private updatePage = async (query: string) => {
    this.updateQueries();
    await this.searchFund(query, 0);
  };

  private onChangeFilter = (e: any) => {
    const key = e.currentTarget.getAttribute('data-attr');
    const category = e.currentTarget.getAttribute('data-category');
    const { query, filterCategoryValueMap } = this.state;
    let filterCategory = filterCategoryValueMap[category];
    filterCategory =
      filterCategory.indexOf(key) === -1
        ? filterCategory.concat(key)
        : filterCategory.filter((filter) => filter !== key);

    const newFilterCategoryMap = {
      ...filterCategoryValueMap,
      [category]: filterCategory,
    };
    this.setState(
      {
        filterCategoryValueMap: newFilterCategoryMap,
      },
      () => {
        this.updatePage(query);
      }
    );
  };

  // private handleFilterClick = (e: any) => {
  //   const key = e.currentTarget.getAttribute('data-attr');
  //   const category = e.currentTarget.getAttribute('data-category');
  //   const { filterCategoryValueMap, filtersToApply } = this.state;
  //   const currentFilters = {
  //     ...filterCategoryValueMap,
  //     ...(filtersToApply || {}),
  //   };
  //   let filterCategory = currentFilters[category];
  //   filterCategory =
  //     filterCategory.indexOf(key) === -1
  //       ? filterCategory.concat(key)
  //       : filterCategory.filter((filter) => filter !== key);

  //   const newFilterCategoryMap = {
  //     ...currentFilters,
  //     [category]: filterCategory,
  //   };

  //   this.setState({ filtersToApply: newFilterCategoryMap });
  // };

  public clearAllFilters = () => {
    const { query, issuingAuthority, selectedTab } = this.state;
    this.setState(
      {
        filterCategoryValueMap: {
          fundType: [],
          purchaseMode: [selectedTab],
          enabled: [],
          issuingAuthority: [issuingAuthority],
          'fundMetaData.exitLoad.percentage': [],
          'categoryFilter.categoryFilterValue': [],
          'fundMetaData.risk': [],
          'fundMetaData.morningStarRating': [],
        },
        filtersToApply: null,
      },
      () => {
        this.updatePage(query);
      }
    );
  };

  // private getFilterModalHeader = () => {
  //   return (
  //     <div className={cx('row', searchStyles['modal-header'])}>
  //       <div
  //         className={cx(
  //           'columns small-9 font--bold text--xlg',
  //           searchStyles['header-cols']
  //         )}
  //       >
  //         Filters
  //       </div>
  //       <div
  //         className={cx(
  //           'columns small-3 text-right font--grey text--uppercase',
  //           searchStyles['header-cols']
  //         )}
  //         onClick={this.clearAllFilters}
  //       >
  //         Clear All
  //       </div>
  //     </div>
  //   );
  // };

  // private handleChangeTabFilter = (e: any) => {
  //   const { currentTarget } = e;
  //   const selectedTabFilter = currentTarget.getAttribute('data-tab');
  //   this.setState({
  //     selectedTabFilter,
  //   });
  // };

  // private onModalClose = () => {
  //   this.setState({
  //     showFilterModal: false,
  //   });
  // };

  // private showFilterModal = () => {
  //   this.setState({
  //     showFilterModal: true,
  //   });
  // };

  // private clearSelection = () => {
  //   this.setState({
  //     filtersToApply: null,
  //     showFilterModal: false,
  //   });
  // };

  // private applyFilters = () => {
  //   const { filtersToApply, query, filterCategoryValueMap } = this.state;
  //   this.setState(
  //     {
  //       filterCategoryValueMap: filtersToApply || filterCategoryValueMap,
  //       showFilterModal: false,
  //     },
  //     () => {
  //       this.updatePage(query);
  //     }
  //   );
  // };

  // private getFilterContentMobile = () => {
  //   const { showFilterModal, selectedTabFilter } = this.state;
  //   const excludeFilter = [
  //     'issuingAuthority',
  //     'categoryFilter.categoryFilterValue',
  //   ];
  //   return (
  //     <div className="mobile-only--display">
  //       <div className="filter-modal">
  //         {showFilterModal ? (
  //           <Modal
  //             fullScreen
  //             hideHeader={showFilterModal}
  //             title=""
  //             onDismiss={this.onModalClose}
  //             padding="1px"
  //             headerPad={20}
  //             marginBottom="0px"
  //           >
  //             {showFilterModal ? this.getFilterModalHeader() : null}
  //             <div className="row ml0 mr0">
  //               {showFilterModal ? (
  //                 <div
  //                   style={{ height: 'calc(100vh - 60px)' }}
  //                   className="columns small-4 pl0 pr0"
  //                 >
  //                   <Tabs
  //                     className="mobile-filter-tabs"
  //                     align="vertical"
  //                     items={filterCategoryMap.filter((f) =>
  //                       excludeFilter.includes(f.key) ? false : true
  //                     )}
  //                     selected={selectedTabFilter}
  //                     switchTabs={this.handleChangeTabFilter}
  //                   />
  //                 </div>
  //               ) : null}
  //               <div
  //                 className={cx('columns pt10', {
  //                   'small-8': showFilterModal,
  //                 })}
  //               >
  //                 {showFilterModal
  //                   ? this.getFilters(selectedTabFilter, true)
  //                   : null}
  //               </div>
  //             </div>
  //             {showFilterModal ? (
  //               <div className={cx('row', searchStyles['bottom-nav'])}>
  //                 <div
  //                   className="columns small-6 text--uppercase font--bold font--grey"
  //                   onClick={this.clearSelection}
  //                 >
  //                   Close
  //                 </div>

  //                 <div
  //                   onClick={this.applyFilters}
  //                   className="columns small-6 text--uppercase font--blue font--bold"
  //                 >
  //                   Apply
  //                 </div>
  //               </div>
  //             ) : null}
  //           </Modal>
  //         ) : null}
  //       </div>
  //       <div className={cx('row', searchStyles['bottom-nav'])}>
  //         <div className="columns small-12" onClick={this.showFilterModal}>
  //           Filters
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  private handleFilterToggle = () => {
    this.setState({
      isFilterOpen: !this.state.isFilterOpen,
    });
  };

  private switchTabs = (e: any) => {
    e.preventDefault();
    const {
      url: { asPath },
    } = this.props;
    const pathname = asPath.split('?')[0];
    const { currentTarget } = e;
    const selectedTab = currentTarget.getAttribute('data-tab');
    const { query, issuingAuthority } = this.state;
    this.setState(
      {
        filterCategoryValueMap: {
          'fundMetaData.risk': [],
          fundType: [],
          purchaseMode: [selectedTab],
          enabled: [],
          issuingAuthority: [issuingAuthority],
          'fundMetaData.exitLoad.percentage': [],
          'categoryFilter.categoryFilterValue': [],
          'fundMetaData.morningStarRating': [],
        },
        filtersToApply: null,
      },
      async () => {
        /**
         * NOTE/TODO
         * This awaits updatePage which awaits searchFund which awaits
         * searchFund API after which state is set with new funds
         * and then selected tab is set in the state. If both the setStates
         * are not batched then it will trigger 2 render cycles and in rare
         * case will change tab first and then refresh funds.
         */
        await this.updatePage(query);
        this.setState({
          selectedTab,
        });
        Router.replaceRoute(`${pathname}?tab=${selectedTab}`);
      }
    );
  };

  // private otherAMCs = () => {
  //   const { otherAMCList } = this.state;
  //   return (
  //     <div className="lil-py-12">
  //       <h4 className="lil-mb-6 lil-text-s-32">
  //         Other AMCs
  //         <a
  //           className="lil-text-s-14 lil-pl-6 lil-text-blue-350 lil-font-semibold"
  //           href="https://cleartax.in/mutual-funds/"
  //         >
  //           See All AMCs
  //         </a>
  //       </h4>

  //       <AmcsList amcList={otherAMCList} parts={3} />
  //     </div>
  //   );
  // };

  // private renderCustomContent = (customContent: string) => {
  //   customContent = customContent.slice(
  //     customContent.indexOf('##', customContent.indexOf('##') + 1)
  //   );
  //   return (
  //     <div className="">
  //       <div className={amcStyles['markdown']}>
  //         <ReactMarkdown source={customContent} />
  //       </div>
  //     </div>
  //   );
  // };

  private handlePaginationItemClick = (e: any) => {
    const { query } = this.state;
    const { target } = e;
    const nextButton = target.getAttribute('data-click-item');
    if (target.getAttribute('data-list-item')) {
      const pageNumber = Number(target.textContent);
      this.searchFund(query, pageNumber - 1);
      this.setState({
        currentSelectedPage: pageNumber - 1,
      });
    } else if (nextButton !== null && nextButton !== undefined) {
      this.searchFund(query, Number(nextButton));
      this.setState({
        currentSelectedPage: Number(nextButton),
      });
    }
  };

  private getPaginationItems() {
    const { totalPages } = this.state;
    const paginationItems = [];
    for (let i = 1; i <= totalPages; i++) {
      paginationItems.push(i);
    }
    return paginationItems;
  }
  public handleChange = (e: any) => {
    this.setState({
      selectedReturnTime: e.target.value,
    });
  };

  public renderTable() {
    const {
      currentFunds,
      currentSelectedPage,
      loading,
      totalResults,
      issuingAuthority,
      selectedReturnTime,
      selectedTab,
      isMobile,
    } = this.state;
    if (currentFunds.length) {
      return (
        <AMCFundTableNew
          itemtype="http://schema.org/Table"
          itemprop="about"
          title={amcTitleCase(issuingAuthority)}
          headingData={AMC_FUND_LIST_HEADER_SEARCH_NEW}
          returnTimeHeading={selectedReturnTime}
          bodyData={getTableItems({
            currentFunds,
            selectedReturnTime,
            selectedTab,
            isMobile,
          })}
          limit={10}
        >
          <div className="lil-flex">
            <div className="lil-w-full lil-text-center lil-pb-4">
              {totalResults > 6 ? (
                <PaginationNew
                  items={this.getPaginationItems()}
                  currentSelectedPage={currentSelectedPage}
                  onItemClick={this.handlePaginationItemClick}
                  maxItemsToShow={5}
                />
              ) : null}
            </div>
          </div>
        </AMCFundTableNew>
      );
    } else if (!loading) {
      return (
        <div className="row">
          <div className="large-8 columns lil-pb-6">
            <p
              className={cx(
                searchStyles['search-title'],
                'center',
                searchStyles['mt50']
              )}
            >
              Uh oh! No results found.
            </p>
          </div>
        </div>
      );
    }
  }
  public renderTopFundsTable() {
    const { issuingAuthority, topFunds, selectedTab, isMobile } = this.state;
    const currentFunds = topFunds;
    const selectedReturnTime = 'return3yr';
    return (
      <AMCFundTableNew
        itemtype="http://schema.org/Table"
        itemprop="about"
        title={amcTitleCase(issuingAuthority)}
        headingData={AMC_FUND_LIST_HEADER_SEARCH_NEW}
        returnTimeHeading="return3yr"
        bodyData={getTableItems({
          currentFunds,
          selectedReturnTime,
          selectedTab,
          isMobile,
        })}
        limit={10}
      >
        <div className="lil-flex">
          <div className="lil-w-full lil-text-center lil-pb-4"></div>
        </div>
      </AMCFundTableNew>
    );
  }

  public async fetchFAQs() {
    const slug = this.props.primarySlug;
    const faqs = await api.getAmcFaqs(slug);
    this.setState({
      amcFaqs: faqs,
    });
  }

  public toggleFAQ = (index: number) => {
    const { expandedFaqIndex } = this.state;
    this.setState({
      expandedFaqIndex: expandedFaqIndex === index ? null : index,
    });
  };

  public async fetchCIOs() {
    const slug = this.props.primarySlug;
    const amcCIOs = await api.getAmcCio(slug);
    this.setState({
      amcCIOs,
    });
  }

  public toggleCIOs = (index: number) => {
    const { expandedCIOIndex } = this.state;
    this.setState({
      expandedCIOIndex: expandedCIOIndex === index ? null : index,
    });
  };

  public async fetchEmail() {
    const slug = this.props.primarySlug;
    const email = await api.getAmcEmail(slug);
    this.setState({
      amcEmail: email,
    });
  }

  public render() {
    const {
      primarySlug,
      statusCode,
      amcBasicsDetails,
      customContent,
      issuingAuthority,
    } = this.props;
    const { selectedTab, tabs, loading } = this.state;
    const amcTitle = amcTitleCase(issuingAuthority);
    const title = `${amcTitle} - Latest Mutual fund Schemes, Statement, Nav, Performance & Returns ${presentYear()}`;
    const description = `${amcTitle} - Detailed analysis & complete track record of ${amcTitle}. Get latest updates on NAV, Dividends, Returns, Risks, Portfolio & Exit Load of this ${amcTitle}.`;
    const breadCrumbItems = [
      {
        link: '/mutual-funds',
        text: 'Mutual funds',
      },
      {
        text: 'Fund Houses',
        link: '/mutual-funds/catalogue',
      },
      {
        text: amcTitleCase(issuingAuthority),
      },
    ];
    return statusCode && statusCode === 404 ? (
      <Error />
    ) : (
      <div className="lil-container lil-py-6 sm:lil-pt-2">
        {
          <Fragment>
            <div className="lil-mt-4 sm:lil-mt-0">
              <BreadCrumb
                breadcrumbs={breadCrumbItems}
                linkStyles={amcStyles['breadcrumb-link']}
              />
            </div>
            <div
              className="lil-flex lil-flex-wrap lil-py-6 lil-my-6 sm:lil-py-0"
              style={{ alignItems: 'center' }}
            >
              <div className="lil-w-1/12 sm:lil-w-full lil-pt-1">
                <LogoImage currentFunds={this.state.currentFunds} />
              </div>
              <div className="lil-w-5/12 sm:lil-w-full lil-pl-12 sm:lil-pl-0 sm:lil-pt-4">
                <h1 className={amcStyles['amc-title']}>
                  {amcTitleCase(issuingAuthority)}
                </h1>
              </div>
              <div className="lil-w-auto lil-ml-auto sm:lil-ml-0 sm:lil-w-full sm:lil-mt-4">
                <AmcBlurb amcData={this.state.amcData} />
              </div>
            </div>
            <div className="sm:lil-pt-4">
              <AboutAmc
                customContent={customContent}
                issuingAuthority={issuingAuthority}
              />
            </div>

            <div className="lil-flex lil-py-12 sm:lil-py-0">
              <div className="sm:lil-w-full">
                <div
                  className={`lil-border-separate lil-w-full lil-shadow-sm lil-border-sm lil-rounded-xl lil-border-spacing-0 lil-border-grey-300 lil-mt-4 sm:lil-border-none sm:lil-shadow-none sm:lil--mx-6 ${amcStyles['mobile-fund-table']}`}
                >
                  <h2
                    className={`${amcStyles['plan-title']} lil-px-8 lil-pt-12 lil-pb-8 sm:lil-pt-6 sm:lil-pb-4 sm:lil-px-6`}
                  >
                    {amcTitleCase(issuingAuthority)} Schemes
                  </h2>
                  <div className="lil-flex lil-flex-wrap">
                    <div className="lil-w-10/12 lil-pl-4 lil-pb-2 sm:lil-w-full sm:lil-pl-0 sm:lil-flex sm:lil-justify-center lil-font-medium sm:lil-pb-4">
                      <Tabs
                        align="horizontal"
                        switchTabs={this.switchTabs}
                        selected={selectedTab}
                        items={tabs}
                        className="newClass"
                      />
                    </div>

                    <div className="lil-w-2/12 lil-flex lil-items-center lil-justify-end sm:lil-w-full sm:lil-flex sm:lil-justify-between sm:lil-mt-2 sm:lil-pl-6 sm:lil-pb-2 sm:lil-pr-4">
                      <ReturnsDropdown
                        handleChange={this.handleChange}
                        selectedValue={this.state.selectedReturnTime}
                      />

                      <FundTableFilter
                        isFilterOpen={this.state.isFilterOpen}
                        handleFilterToggle={this.handleFilterToggle}
                        clearAllFilters={this.clearAllFilters}
                        filtersToApply={this.state.filtersToApply}
                        filterCategoryValueMap={
                          this.state.filterCategoryValueMap
                        }
                        filterCategoryMap={filterCategoryMap}
                        filterDataMap={filterDataMap}
                        onChangeFilter={this.onChangeFilter}
                        selectedTabFilter={this.state.selectedTabFilter}
                        isMobile={this.state.isMobile}
                      />
                    </div>
                  </div>
                  {loading ? <Loader /> : this.renderTable()}
                </div>
                <AmcBasicInfo
                  amcBasicsDetails={amcBasicsDetails}
                  issuingAuthority={issuingAuthority}
                />
                <CIOs
                  amcCIOs={this.state.amcCIOs}
                  expandedCIOIndex={this.state.expandedCIOIndex}
                  toggleCIO={this.toggleCIOs}
                  amcName={amcTitleCase(issuingAuthority)}
                />
                {/* {this.otherAMCs()}
                <ToolAndCalc />
                {customContent &&
                  customContent.length > 5 &&
                  this.renderCustomContent(customContent)} */}
                <div
                  className={`lil-border-separate lil-w-full lil-shadow-sm lil-border-sm lil-rounded-xl lil-border-spacing-0 lil-border-grey-300 lil-mt-4 sm:lil-border-none sm:lil-shadow-none sm:lil--mx-6 ${amcStyles['mobile-fund-table']} sm:lil-mt-4`}
                >
                  <h2
                    className={`${amcStyles['plan-title']} lil-px-8 lil-pt-12 lil-pb-8 sm:lil-py-4 sm:lil-px-6`}
                  >
                    Top 10 Best {amcTitleCase(issuingAuthority)} to Invest
                  </h2>
                  {this.renderTopFundsTable()}
                </div>
                <HowToInvest issuingAuthority={issuingAuthority} />
                <DocumentsRequired issuingAuthority={issuingAuthority} />
                <CustomerCare
                  amcBasicsDetails={amcBasicsDetails}
                  issuingAuthority={issuingAuthority}
                  amcEmail={this.state.amcEmail}
                />
                <FAQs
                  amcFaqs={this.state.amcFaqs}
                  expandedFaqIndex={this.state.expandedFaqIndex}
                  toggleFAQ={this.toggleFAQ}
                />
              </div>
            </div>
            <Header
              title={title}
              description={description}
              canonicalUrl={`https://cleartax.in/mutual-funds/${primarySlug}`}
            />
          </Fragment>
        }
      </div>
    );
  }
}

export default AmcFundsListNew;



// WEBPACK FOOTER //
// ./pages/amcNew.tsx